
import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import { ScheduledPickup } from '@/features/dashboard/types';
import PickupItem from '@/features/dashboard/components/widgets/scheduledPickups/PickupItem.vue';

@Component({
  components: {
    PickupItem,
  },
})
export default class Content extends Vue {
  get schedulePickups(): Array<ScheduledPickup> {
    return this.$store.getters.getScheduledPickups || null;
  }

  get pickupsToday(): Array<ScheduledPickup> {
    return this.schedulePickups.filter((el: ScheduledPickup) => {
      const mTodayDate = moment();
      const mPickupDate = moment(el.pickupDate);

      const pickupToday = mTodayDate.year() === mPickupDate.year()
        && mTodayDate.month() === mPickupDate.month()
        && mTodayDate.date() === mPickupDate.date();

      return pickupToday && el;
    });
  }

  get pickupsUpcoming(): Array<ScheduledPickup> {
    return this.schedulePickups.filter((el: ScheduledPickup) => !this.pickupsToday.includes(el));
  }
}
